import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObj } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { PRODUCT_IMAGE_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

export function useProductImageZoom(
  obj: ProductObj | ProductBaseVariantObj | null | undefined
) {
  const { openOverlay } = useOverlay(PRODUCT_IMAGE_OVERLAY)

  return useEvent(() => {
    if (!obj) return
    openOverlay({ obj })
  })
}
